import React from 'react';
import './FullPageLoader.css';

const FullPageLoader = () => (
  <div className="full-page-loader" role="status" aria-live="polite">
    <div className="full-page-loader-wrap">
      <div className="full-page-loader-ring">
        <span className="segment s1" />
        <span className="segment s2" />
        <span className="segment s3" />
        <span className="segment s4" />
        <span className="segment s5" />
        <span className="segment s6" />
        <span className="segment s7" />
        <span className="segment s8" />
      </div>
      <div className="full-page-loader-pulse" />
    </div>
    <span className="visually-hidden">Loading...</span>
  </div>
);

export default FullPageLoader;
